import axiosInstance from "./api/axiosInstance";

const ITEMS_PER_PAGE = 10;

/**
 * Busca o histórico de valorizações com filtros e paginação.
 * @param {object} filters - Objeto contendo os filtros.
 * @param {string} filters.clientId - ID do cliente (obrigatório).
 * @param {number} [filters.page=1] - A página a ser buscada.
 * @param {string} [filters.contractId] - ID do contrato para filtrar.
 * @param {string} [filters.date] - Data para filtrar (formato YYYY-MM-DD).
 * @returns {Promise<object>} Os dados do histórico, incluindo itens e informações de paginação.
 */
const searchHistory = async (filters) => {
    const params = {
        clientId: filters.clientId,
        page: filters.page || 1,
        pageSize: ITEMS_PER_PAGE,
        contractId: filters.contractId || null, // Envia nulo se vazio
        date: filters.date || null,
    };
    // pedrinnnnn
    const response = await axiosInstance.get('valorization-history/search', { params });
    return response.data;
};

export const valorizationService = {
    searchHistory,
};